<svg
  id="line-projection-chart"
  [attr.width]="svgWidth"
  [attr.height]="svgHeight">
</svg>
<div *ngIf="showLoader" class="loader-overlay">
  <div class="loader-overlay__loader"></div>
</div>
